// @ts-nocheck
import { motion } from 'framer-motion';
import { Text, YStack } from 'tamagui';

import { useIsMobile } from '../../hooks/useIsMobile';
import { useMotion } from '../../hooks/useMotion';
import { SubscribeForm } from './SubscribeForm';

export function CTASection() {
  const isMobile = useIsMobile();
  const { sectionReveal } = useMotion();

  return (
    <YStack
      id="cta"
      paddingVertical={120}
      paddingHorizontal="$5"
      alignItems="center"
      backgroundColor="$color2"
      borderTopWidth={1}
      borderColor="$borderColor"
    >
      <YStack alignItems="center" maxWidth={600} gap="$5">
        <motion.div
          {...sectionReveal}
          viewport={{ once: true }}
          style={{ textAlign: 'center' }}
        >
          <Text
            fontSize={isMobile ? 34 : 48}
            fontWeight="700"
            textAlign="center"
            letterSpacing={-2}
            lineHeight={isMobile ? 40 : 54}
            color="$color12"
          >
            Stop switching.{'\n'}Start finding.
          </Text>
        </motion.div>
        <motion.div
          {...sectionReveal}
          viewport={{ once: true }}
          style={{ textAlign: 'center' }}
        >
          <Text
            fontSize={isMobile ? 16 : 18}
            textAlign="center"
            color="$color9"
            lineHeight={28}
          >
            Join the waitlist and be the first to unify your tools
            into one searchable workspace.
          </Text>
        </motion.div>
        <motion.div
          {...sectionReveal}
          viewport={{ once: true }}
          style={{ width: '100%', display: 'flex', justifyContent: 'center' }}
        >
          <YStack marginTop="$4" width="100%" alignItems="center">
            <SubscribeForm variant="compact" />
          </YStack>
        </motion.div>
      </YStack>
    </YStack>
  );
}
